var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "menu-block",
      class: {
        "is-open": !_vm.groupCollapsible,
        "mobile-clickable": _vm.groupCollapsible && _vm.title,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "title-region",
          on: {
            click: function ($event) {
              return _vm.collapse()
            },
          },
        },
        [
          _c("h4", { staticClass: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.groupCollapsible
            ? [
                _c(
                  "div",
                  {
                    staticClass: "menu-block-navigation-icon-container",
                    class: _vm.contentStateDisplay.classes,
                    attrs: {
                      title: _vm.contentStateDisplay.names,
                      alt: _vm.contentStateDisplay.names,
                    },
                  },
                  [
                    _c(
                      "icon-base",
                      { attrs: { "icon-name": "chevron-down" } },
                      [_c("icon-chevron-down")],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "navigation-region",
          class: { "mobile-collapsed": _vm.collapsed && _vm.title },
        },
        [
          _c(
            "ul",
            { staticClass: "nav-list" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "li",
                {
                  key: `nav-list-${item.id}-${index}`,
                  staticClass: "nav-item",
                },
                [
                  _c("HighlightButton", {
                    attrs: {
                      "router-link": true,
                      url: item.linkUrl,
                      title: item.linkText,
                      "button-type": "default",
                      "url-new-window": item.linkTarget === "_blank",
                    },
                    on: {
                      "highlight-button-click": function ($event) {
                        return _vm.$emit("close-dropdown")
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }